import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@shared/authentication.service';
import { from, mergeMap } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) =>
  from(inject(AuthenticationService).getToken()).pipe(
    mergeMap(token => {
      if (token) {
        request = request.clone({
          setHeaders: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Authorization: `Bearer ${token}`,
          },
        });
      }

      return next(request);
    }),
  );
